import React from 'react';
import { UserAutocomplete } from '@/components/selects/UserAutocomplete';
import { useListAllUsersQuery } from '../../users/api/usersApi';
import { useUserSearchOptions } from '../useUserSearchOptions';
import { ADMIN_PICKER_OPTION_LIMIT } from './constants';
import { fuseFilterOptions } from './fuseFilterOptions';

/**
 * Pick users from every user, searchable by name, email, phone, delegated emails and broker
 * group names (best matches first), listing at most ADMIN_PICKER_OPTION_LIMIT matches at a
 * time. value/onChange are user ids
 * (an array when multiple, the default). excludeIds are left out of the options, e.g. users
 * already added. Deactivated users are still offered, with UserAutocomplete's "Inactive"
 * chip. Other props go to UserAutocomplete.
 */
export const AdminUserPicker = ({ excludeIds = [], multiple = true, ...props }) => {
	const { data: users = [], isLoading } = useListAllUsersQuery();
	const searchOptions = useUserSearchOptions();

	return (
		<UserAutocomplete
			options={users.filter((user) => !excludeIds.includes(user.id))}
			markInactive
			multiple={multiple}
			searchable
			filterOptions={fuseFilterOptions(searchOptions)}
			optionLimit={ADMIN_PICKER_OPTION_LIMIT}
			loading={isLoading}
			disabled={isLoading}
			{...props}
		/>
	);
};
